import React, { useState } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  CircularProgress,
} from '@mui/material';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAvailableReports } from '../../hooks/Reports/useAvailableReports';

const Reports = () => {
  const ReqComponent = () => <span className="text-danger ">*</span>;
  const [fromDate, setFromDate] = useState(new Date('2025-03-09'));
  const [toDate, setToDate] = useState(new Date('2025-03-15'));
  const [showDatePickers, setShowDatePickers] = useState(false);
  const dateFrom = moment(fromDate).format('YYYY-MM-DD');
  const dateTo = moment(toDate).format('YYYY-MM-DD');
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  const { filteredReports, isReportsLoading } = useAvailableReports();

  const getEmployeeReport = () => {
    setLoading(true);
    ApiService.get(`/employee-report?from=${dateFrom}&to=${dateTo}`)
      .then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'report.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        setLoading(false);
        setShowDatePickers(false);
        setFromDate(new Date('2025-03-09'));
        setToDate(new Date('2025-03-15'));
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  const SwapReport = () => {
    navigate('/firehouse/reports/swap');
  };

  const openReportDetails = (reportName) => {
    navigate(`${reportName}`);
  };

  const ShiftAllocationReport = () => {
    navigate('/firehouse/reports/shift-allocation-report');
  };

  return (
    <Paper className="p-4" sx={{ marginTop: '1rem' }}>
      <Typography variant="h5">Reports</Typography>
      {isReportsLoading ? (
        <Box
          sx={{ minHeight: '30px' }}
          className="w-10 h-10 d-flex justify-content-center align-items-center"
        >
          <CircularProgress size={32} />
        </Box>
      ) : (
        <Box className="mt-4">
          <Grid container spacing={2}>
            <Grid item xs={4} md={4} sm={12}>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #EAECF0',
                  boxShadow: `
                                    0px 5px 15px 0px rgba(31, 64, 148, 0.02),
                                    0px 10px 11px 0px rgba(22, 38, 61, 0.02),
                                    0px 3px 6px 0px rgba(4, 43, 141, 0.03)
                                `,
                  borderRadius: '20px',
                  height: showDatePickers ? '222px' : '146px',
                  padding: '22px',
                  transition: 'height 0.3s ease-in-out',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                  }}
                  onClick={() => setShowDatePickers((prev) => !prev)}
                >
                  <p
                    style={{
                      fontSize: '22px',
                      fontWeight: '700',
                      fontFamily: 'karla',
                    }}
                  >
                    Harpers Report
                  </p>
                  <img src="/images/report-1.png" height="45px" width="45px" />
                </div>

                {showDatePickers && (
                  <div className="mt-1">
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <label style={{ fontSize: '14px' }}>
                          For <ReqComponent />
                        </label>
                        <Box className="mt-1">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              value={fromDate}
                              onChange={(e) => setFromDate(e)}
                              sx={{
                                width: '100%',
                                '& .MuiInputBase-root': {
                                  height: '48px',
                                  fontSize: '14px',
                                },
                              }}
                              dateInputIcon={<CalendarTodayIcon />}
                            />
                          </LocalizationProvider>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <label style={{ fontSize: '14px' }}>
                          To <ReqComponent />
                        </label>
                        <Box className="mt-1">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              value={toDate}
                              onChange={(e) => setToDate(e)}
                              sx={{
                                width: '100%',
                                '& .MuiInputBase-root': {
                                  height: '48px',
                                  fontSize: '14px',
                                },
                              }}
                              dateInputIcon={<CalendarTodayIcon />}
                            />
                          </LocalizationProvider>
                        </Box>
                      </Grid>
                    </Grid>
                  </div>
                )}
                {loading ? (
                  <Box className="mt-2">
                    <CircularProgress />
                  </Box>
                ) : (
                  <ButtonTheme
                    type="submit"
                    // disabled={!showDatePickers}
                    variant="filled"
                    color="primary"
                    style={{ marginTop: '15px' }}
                    onClick={() => {
                      getEmployeeReport();
                    }}
                  >
                    Fetch Report
                  </ButtonTheme>
                )}
              </Box>
            </Grid>
            <Grid item xs={4} md={4} sm={12}>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #EAECF0',
                  boxShadow: `                                 0px 5px 15px 0px rgba(31, 64, 148, 0.02),
                                    0px 10px 11px 0px rgba(22, 38, 61, 0.02),
                                    0px 3px 6px 0px rgba(4, 43, 141, 0.03)
                                `,
                  borderRadius: '20px',
                  height: showDatePickers ? '222px' : '146px',
                  padding: '22px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                  }}
                  onClick={() => setShowDatePickers((prev) => !prev)}
                >
                  <p
                    style={{
                      fontSize: '22px',
                      fontWeight: '700',
                      fontFamily: 'karla',
                    }}
                  >
                    Swap Report
                  </p>
                  <img src="/images/report-1.png" height="45px" width="45px" />
                </div>

                {showDatePickers && (
                  <div className="pt-3">
                    <p style={{ fontSize: '14px', color: '#555555' }}>
                      A Swap Report in the context of employee shift management
                      typically refers to a record of shift change or swap
                      requests between employees.
                    </p>
                  </div>
                )}

              <ButtonTheme
                type="submit"
                disabled={!showDatePickers}
                variant="filled"
                color="primary"
                onClick={SwapReport}
                style={{ marginTop: showDatePickers ? '0px' : '16px' }}
              >
                Swap Report
              </ButtonTheme>
            </Box>
          </Grid>
          <Grid item xs={4} md={4} sm={12}>
            <Box
              sx={{
                backgroundColor: '#ffffff',
                border: '1px solid #EAECF0',
                boxShadow: `
                                    0px 5px 15px 0px rgba(31, 64, 148, 0.02),
                                    0px 10px 11px 0px rgba(22, 38, 61, 0.02),
                                    0px 3px 6px 0px rgba(4, 43, 141, 0.03)
                                `,
                borderRadius: '20px',
                height: showDatePickers ? '222px' : '146px',
                padding: '22px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                }}
                onClick={() => setShowDatePickers((prev) => !prev)}
              >
                <p
                  style={{
                    fontSize: '22px',
                    fontWeight: '700',
                    fontFamily: 'karla',
                  }}
                >
                  Shift Allocation Report
                </p>
                <img src="/images/report-1.png" height="45px" width="45px" />
              </div>

              {showDatePickers && (
                <div className="pt-3">
                  <p style={{ fontSize: '14px', color: '#555555' }}>
                    A Shift Allocation Report in the context of employee shift
                    management typically refers to a record of shift allocation
                    of employees.
                  </p>
                </div>
              )}

              <ButtonTheme
                type="submit"
                disabled={!showDatePickers}
                variant="filled"
                color="primary"
                onClick={ShiftAllocationReport}
                style={{ marginTop: showDatePickers ? '0px' : '16px' }}
              >
                Fetch Report
              </ButtonTheme>
            </Box>
          </Grid>
          <Grid container spacing={2} className="mt-1">
            {filteredReports.map((item) => (
              <ReportCard
                key={item.id}
                title={item.title}
                showDatePickers={false}
                openReportDetails={openReportDetails}
                handle={item.link}
              />
            ))}
          </Grid>
        </Grid>
        </Box>
      )}
    </Paper>
  );
};

const ReportCard = ({ showDatePickers, openReportDetails, title, handle }) => {
  return (
    <Grid item xs={4} md={4} sm={12}>
      <Box
        sx={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(235, 236, 240, 0.6)',
          boxShadow: `
                            0px 5px 15px 0px rgba(31, 64, 148, 0.02),
                            0px 10px 11px 0px rgba(22, 38, 61, 0.02),
                            0px 3px 6px 0px rgba(4, 43, 141, 0.03)
                            `,
          borderRadius: '20px',
          height: showDatePickers ? '222px' : 'fit-content',
          padding: '22px',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p
            style={{
              fontSize: '22px',
              fontWeight: '700',
              fontFamily: 'karla',
            }}
          >
            {title}
          </p>
          <img src="/images/report-1.png" height="45px" width="45px" alt="" />
        </div>
        <Box
          sx={{
            marginTop: showDatePickers ? '90px' : '15px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '15px',
          }}
        >
          <ButtonTheme
            variant="filled"
            color="primary"
            onClick={() => openReportDetails(handle)}
          >
            Report Details
          </ButtonTheme>
        </Box>
      </Box>
    </Grid>
  );
};

export default Reports;
